import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "create-ev-page" }
const _hoisted_2 = {
  key: 0,
  class: "screen-like"
}
const _hoisted_3 = { class: "info-grid" }
const _hoisted_4 = { class: "info-row" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = { class: "info-row" }
const _hoisted_7 = { class: "info-row" }
const _hoisted_8 = { class: "info-row" }
const _hoisted_9 = { class: "info-row" }
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = { class: "info-row" }
const _hoisted_12 = { class: "info-row" }
const _hoisted_13 = { class: "features-list" }
const _hoisted_14 = { class: "feature-item" }
const _hoisted_15 = { class: "feature-item" }
const _hoisted_16 = { class: "feature-item" }
const _hoisted_17 = { class: "feature-item" }
const _hoisted_18 = { class: "feature-item" }
const _hoisted_19 = { class: "feature-item" }
const _hoisted_20 = { class: "photo-grid" }
const _hoisted_21 = { class: "upload-box" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "upload-art"
}
const _hoisted_24 = ["onChange"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "photo-caption" }
const _hoisted_27 = { class: "gps-grid" }
const _hoisted_28 = { class: "info-row" }
const _hoisted_29 = { class: "info-row" }
const _hoisted_30 = { class: "info-row" }
const _hoisted_31 = { class: "save-wrap" }

import { ref, onMounted, computed } from 'vue'
import { ElMessage } from 'element-plus'
import {
  getEvCarGeotekProfiles,
  getEvCarGeotekLocation,
  createEvCarProfile,
  updateEvCarProfile,
  getEvCarProfiles,
  EvCarProfile,
  UploadedImage,
  uploadEvCarImage,
} from '@/api/car-ev-data'
import { useAuthStore } from '@/store/auth/store'
import { CAR_TYPE_OPTIONS } from '@/constants/select-options'

type GeotekLocation = { lat: number; lng: number }


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateEvCar',
  setup(__props) {

const authStore = useAuthStore()
const geotekCars = ref<{ id: string; name: string }[]>([])
const copyCarsList = ref<{ id: string; name: string }[]>([])
const fullCarsList = ref<EvCarProfile[]>([])
const selectedGeotekCarId = ref<string | undefined>(undefined)
const isCarSelected = ref(false)
const imageFields = ref<(UploadedImage | null)[]>(new Array(12).fill(null))
const carId = ref<string | null>(null)
const isLoading = ref(false)
const formRef = ref()

const defaultForm: Omit<EvCarProfile, 'user_id' | 'external_id'> = {
  model_id: undefined,
  model_make_id: '',
  model_name: '',
  model_year: (undefined as unknown) as number,
  battery_capacity: (undefined as unknown) as number,
  charging_connector_type: '',
  charging_time: (undefined as unknown) as number,
  range_per_full_charge: (undefined as unknown) as number,
  price_per_minute_ev: 0,
  price_per_km_ev: 0,
  pause_price_ev: 0,
  price_per_minute_up_to_100_km_ev: 0,
  price_per_minute_above_100_km_ev: 0,
  price_per_hour_up_to_100_km_ev: 0,
  price_per_hour_above_100_km_ev: 0,
  deposit_amount_ev: 0,
  car_type: '',
  transmission: 'automatic',
  fuel_type: 'electric',
  no_branded_title: false,
  plate_number: '',
  car_description: '',
  charging_included: false,
  battery_included: false,
  gps: false,
  air_conditioner: false,
  bluetooth_stereo: false,
  wifi_internet: false,
  fire_extinguisher: false,
  ownership_permit: [],
  charging_policy: '',
  seats: 4,
  doors: 4,
  reservation_timer: undefined,
  pause_limit: undefined,
  pause_usage_limit: false,
  no_smoking: false,
  current_location: '',
  location: { lat: 0, lng: 0 } as GeotekLocation,
  type_connection_geotek: '',
  min_age_requirement: 18,
}

const form = ref<EvCarProfile>({
  ...defaultForm,
  user_id: authStore.session?.user?.id || '',
  external_id: '',
})

const types = [
  'frontImage',
  'backImage',
  'leftImage',
  'rightImage',
  'frontSalonImage',
  'backSalonImage',
  'additionalImage1',
  'additionalImage2',
  'additionalImage3',
  'additionalImage4',
  'additionalImage5',
  'additionalImage6',
]

// підписи під 12 слотів
const displayPhotoLabels = [
  'Front Image',
  'Back Image',
  'Left Image',
  'Right Image',
  'Front Salon Image',
  'Back Salon Image',
  'Additional Image 1',
  'Additional Image 2',
  'Additional Image 3',
  'Additional Image 4',
  'Additional Image 5',
  'Additional Image 6',
]

// показувати екран лише після вибору авто + типу
const canShowScreen = computed(
  () => isCarSelected.value && !!form.value.type_connection_geotek
)

const rules = {
  model_make_id: [
    { required: true, message: 'Make ID is required', trigger: 'blur' },
  ],
  model_name: [
    { required: true, message: 'Model Name is required', trigger: 'blur' },
  ],
  model_year: [
    { required: true, message: 'Model Year is required', trigger: 'blur' },
    {
      type: 'number' as const,
      min: 1990,
      max: 2025,
      message: 'Model year must be between 1990 and 2024',
      trigger: 'blur',
    },
  ],
  battery_capacity: [
    {
      required: true,
      message: 'Battery capacity is required',
      trigger: 'blur',
    },
    {
      type: 'number' as const,
      min: 10,
      max: 200,
      message: 'Battery capacity must be between 10 and 200 kWh',
      trigger: 'blur',
    },
  ],
  charging_connector_type: [
    {
      required: true,
      message: 'Connector type is required',
      trigger: 'change',
    },
  ],
  range_per_full_charge: [
    {
      required: true,
      message: 'Range per charge is required',
      trigger: 'blur',
    },
    {
      type: 'number' as const,
      min: 100,
      max: 600,
      message: 'Range per charge must be between 100 and 600 km',
      trigger: 'blur',
    },
  ],
  car_type: [
    { required: true, message: 'Car type is required', trigger: 'change' },
  ],
  car_description: [
    { required: true, message: 'Car description is required', trigger: 'blur' },
  ],
  type_connection_geotek: [
    {
      required: true,
      message: 'Connection type is required',
      trigger: 'change',
    },
  ],
  plate_number: [
    { required: true, message: 'Plate number is required', trigger: 'blur' },
  ],
  seats: [{ required: true, message: 'Seats are required', trigger: 'blur' }],
  doors: [{ required: true, message: 'Doors are required', trigger: 'blur' }],
}

onMounted(async () => {
  try {
    const response = await getEvCarGeotekProfiles({})
    const geotekObjects = response.data || []
    geotekCars.value = geotekObjects.map((car: any) => ({
      id: car.id,
      name: car.name,
    }))
  } catch {
    ElMessage.error('Failed to load Geotek cars')
  }

  try {
    const copyResponse = await getEvCarProfiles({
      status: 'active',
      perPage: 1000,
    })

    let cars = (copyResponse.data as any).data

    // Handle nested data structure: { data: { data: [], meta: {} } }
    if (!Array.isArray(cars) && cars?.data && Array.isArray(cars.data)) {
      cars = cars.data
    }

    if (!Array.isArray(cars)) {
      cars = []
    }

    fullCarsList.value = cars

    copyCarsList.value = cars.map((car: any) => ({
      id: car.id,
      name: `${car.plate_number} (${car.model_name})`,
    }))
  } catch (error) {
    console.error('Failed to load cars for copy', error)
  }
})

const handleGeotekCarSelect = async (carId: string) => {
  selectedGeotekCarId.value = carId
  form.value.external_id = carId

  try {
    // легка пауза, як було
    await new Promise(resolve => setTimeout(resolve, 1000))
    const coords = await getEvCarGeotekLocation(carId)
    form.value.location = { lat: coords.lat, lng: coords.lng }
  } catch (error) {
    console.error('❌ Failed to get Geotek location:', error)
    ElMessage.error('Failed to load location from Geotek')
  }

  isCarSelected.value = true
}

const handleCopyCarSelect = (id: string) => {
  const car: any = fullCarsList.value.find((c: any) => c.id === id)
  if (!car) return

  form.value.model_make_id = car.model_make_id
  form.value.model_name = car.model_name
  form.value.model_year = car.model_year
  form.value.battery_capacity = car.battery_capacity
  form.value.charging_connector_type = car.charging_connector_type
  form.value.range_per_full_charge = car.range_per_full_charge
  form.value.charging_time = car.charging_time
  form.value.price_per_minute_ev = car.price_per_minute_ev
  form.value.price_per_km_ev = car.price_per_km_ev
  form.value.pause_price_ev = car.pause_price_ev
  form.value.price_per_minute_up_to_100_km_ev =
    car.price_per_minute_up_to_100_km_ev
  form.value.price_per_minute_above_100_km_ev =
    car.price_per_minute_above_100_km_ev
  form.value.price_per_hour_up_to_100_km_ev = car.price_per_hour_up_to_100_km_ev
  form.value.price_per_hour_above_100_km_ev = car.price_per_hour_above_100_km_ev
  form.value.deposit_amount_ev = car.deposit_amount_ev
  form.value.car_type = car.car_type
  form.value.car_description = car.car_description
  form.value.doors = car.doors
  form.value.seats = car.seats
  form.value.air_conditioner = car.air_conditioner
  form.value.no_smoking = car.no_smoking
  form.value.gps = car.gps

  // Map images
  // types array: ['frontImage', 'backImage', ...]
  // car.images: array of objects { type: 'frontImage', secure_url: '...' }

  // Clear existing images first
  imageFields.value = new Array(12).fill(null)

  const images = car.images
  if (images && Array.isArray(images)) {
    types.forEach((type, index) => {
      const foundImg = images.find((img: any) => img.type === type)
      if (foundImg) {
        imageFields.value[index] = {
          preview: foundImg.secure_url,
          file: undefined,
        }
      }
    })
  }

  ElMessage.success('Car data copied!')
}

const handleTransmissionChange = (value: boolean) => {
  // Backend only accepts 'automatic', so we always set it to 'automatic'
  form.value.transmission = 'automatic'
}

const handleImageUpload = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]

  if (file) {
    const reader = new FileReader()
    reader.onload = () => {
      imageFields.value[index] = { file, preview: reader.result as string }
    }
    reader.onerror = error => {
      console.error(`❌ FileReader error for index ${index}:`, error)
    }
    reader.readAsDataURL(file)
  }
  // Clear input value to allow re-selecting the same file
  target.value = ''
}

const removeImage = (index: number) => {
  imageFields.value[index] = null
}

const submitForm = async () => {
  if (isLoading.value) return // Prevent multiple submissions

  try {
    isLoading.value = true

    if (!form.value.external_id) {
      ElMessage.warning('Please select a Geotek car first')
      return
    }
    if (!form.value.type_connection_geotek) {
      ElMessage.warning('Please select connection type')
      return
    }
    // if (!form.value.location || form.value.location.lat === 0) {
    //   ElMessage.warning('Location is not set from Geotek yet')
    //   return
    // }

    const response = await createEvCarProfile(form.value)

    carId.value = response.data?.id ?? null

    // Upload images if any are selected
    const hasImages = imageFields.value.some(field => field !== null)
    if (hasImages) {
      // Create array of upload promises only for images that exist and have a file to upload
      const uploadPromises: Promise<any>[] = []

      types.forEach((type, index) => {
        const field = imageFields.value[index]
        if (field && field.file) {
          const uploadPromise = uploadEvCarImage(carId.value!, field.file, type)
            .then(result => {
              return result
            })
            .catch(error => {
              console.error(`❌ Failed to upload ${type}:`, error)
              throw error
            })

          uploadPromises.push(uploadPromise)
        }
      })

      if (uploadPromises.length > 0) {
        const results = await Promise.all(uploadPromises)
        ElMessage.success('EV Car created with images!')
      } else {
        ElMessage.success('EV Car Profile created!')
      }
    } else {
      ElMessage.success('EV Car Profile created!')
    }

    // Reset form after successful creation
    resetForm()
  } catch (error) {
    console.error('❌ Failed to create EV Car Profile:', error)
    ElMessage.error('Failed to create EV Car Profile')
  } finally {
    isLoading.value = false
  }
}

const resetForm = () => {
  // Reset form to default values
  form.value = {
    ...defaultForm,
    user_id: authStore.session?.user?.id || '',
    external_id: '',
  }

  // Reset image fields
  imageFields.value = new Array(12).fill(null)

  // Reset car ID
  carId.value = null

  // Reset selection states
  selectedGeotekCarId.value = undefined
  isCarSelected.value = false

  // Reset form validation if needed
  if (formRef.value) {
    formRef.value.resetFields()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: form.value,
      rules: rules,
      ref_key: "formRef",
      ref: formRef,
      "label-position": "top",
      class: "top-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "Choose a car from the Geotek service:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: selectedGeotekCarId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedGeotekCarId).value = $event)),
              placeholder: "Select Geotek Car",
              onChange: handleGeotekCarSelect,
              style: {"max-width":"420px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(geotekCars.value, (car) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: car.id,
                    label: `${car.name}  id=${car.id}`,
                    value: car.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Type of connection Geotek system",
          prop: "type_connection_geotek"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: form.value.type_connection_geotek,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.type_connection_geotek) = $event)),
              placeholder: "Select connection type",
              style: {"max-width":"420px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Rele",
                  value: "Rele"
                }),
                _createVNode(_component_el_option, {
                  label: "CAN",
                  value: "CAN"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Copy from car (optional):" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: form.value.copy_from_id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.copy_from_id) = $event)),
              placeholder: "Select car to copy from",
              style: {"max-width":"420px"},
              clearable: "",
              filterable: "",
              onChange: handleCopyCarSelect
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(copyCarsList.value, (car) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: car.id,
                    label: car.name,
                    value: car.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (canShowScreen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "section-card"
          }, {
            default: _withCtx(() => [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "section-title" }, "VEHICLE INFO", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[20] || (_cache[20] = _createElementVNode("span", { class: "info-label" }, "Make", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.model_make_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.model_make_id) = $event)),
                    placeholder: "tap to enter",
                    class: "ghost-input",
                    style: {"width":"200px"},
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "info-label" }, "Model", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.model_name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.model_name) = $event)),
                    placeholder: "tap to enter",
                    class: "ghost-input",
                    style: {"width":"200px"},
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "info-label" }, "Year", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.model_year,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.model_year) = $event)),
                    modelModifiers: { number: true },
                    type: "number",
                    placeholder: "1990-2024",
                    class: "ghost-input",
                    style: {"width":"200px"},
                    min: "1990",
                    max: "2024"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "info-label" }, "Plate Number", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.plate_number,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.plate_number) = $event)),
                    placeholder: "tap to enter",
                    class: "ghost-input",
                    style: {"width":"200px"},
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "info-label" }, "Battery Capacity (kWh)", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.battery_capacity,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.battery_capacity) = $event)),
                    modelModifiers: { number: true },
                    type: "number",
                    placeholder: "10-200 kWh",
                    class: "ghost-input",
                    style: {"width":"200px"},
                    min: "10",
                    max: "200"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "info-label" }, "Charging Connector Type", -1)),
                  _createVNode(_component_el_select, {
                    modelValue: form.value.charging_connector_type,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.charging_connector_type) = $event)),
                    placeholder: "Select connector type",
                    class: "ghost-input",
                    style: {"width":"200px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Type 1 (CCS)",
                        value: "Type 1 (CCS)"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Type 2 (Mennekes)",
                        value: "Type 2 (Mennekes)"
                      }),
                      _createVNode(_component_el_option, {
                        label: "CHAdeMO",
                        value: "CHAdeMO"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Tesla Supercharger",
                        value: "Tesla Supercharger"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "info-label" }, "Range per Charge (km)", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.range_per_full_charge,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.range_per_full_charge) = $event)),
                    modelModifiers: { number: true },
                    type: "number",
                    placeholder: "100-600 km",
                    class: "ghost-input",
                    style: {"width":"200px"},
                    min: "100",
                    max: "600"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "info-label" }, "Car Type", -1)),
                  _createVNode(_component_el_select, {
                    modelValue: form.value.car_type,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.car_type) = $event)),
                    placeholder: "Select car type",
                    class: "ghost-input",
                    style: {"width":"200px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Sedan",
                        value: "sedan"
                      }),
                      _createVNode(_component_el_option, {
                        label: "SUV",
                        value: "suv"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Hatchback",
                        value: "hatchback"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Wagon",
                        value: "wagon"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Coupe",
                        value: "coupe"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Convertible",
                        value: "convertible"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "info-label" }, "Car Description", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.car_description,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.car_description) = $event)),
                    type: "textarea",
                    placeholder: "Enter car description",
                    class: "ghost-input",
                    rows: 3
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1,
            __: [29]
          }),
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "section-card"
          }, {
            default: _withCtx(() => [
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "section-title" }, "FEATURES", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_switch, {
                    "model-value": form.value.doors === 4,
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (form.value.doors = $event ? 4 : 2))
                  }, null, 8, ["model-value"]),
                  _cache[30] || (_cache[30] = _createElementVNode("i", { class: "feature-ico i-door" }, null, -1)),
                  _cache[31] || (_cache[31] = _createElementVNode("span", null, "4 Doors", -1))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_el_switch, {
                    "model-value": form.value.seats === 4,
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (form.value.seats = $event ? 4 : 2))
                  }, null, 8, ["model-value"]),
                  _cache[32] || (_cache[32] = _createElementVNode("i", { class: "feature-ico i-seat" }, null, -1)),
                  _cache[33] || (_cache[33] = _createElementVNode("span", null, "4 x Seats", -1))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_switch, {
                    modelValue: form.value.air_conditioner,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.air_conditioner) = $event))
                  }, null, 8, ["modelValue"]),
                  _cache[34] || (_cache[34] = _createElementVNode("i", { class: "feature-ico i-ac" }, null, -1)),
                  _cache[35] || (_cache[35] = _createElementVNode("span", null, "Air Conditioner", -1))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_switch, {
                    "model-value": true,
                    disabled: ""
                  }),
                  _cache[36] || (_cache[36] = _createElementVNode("i", { class: "feature-ico i-auto" }, null, -1)),
                  _cache[37] || (_cache[37] = _createElementVNode("span", null, "Automatic Transmission", -1))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_switch, {
                    modelValue: form.value.no_smoking,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.no_smoking) = $event))
                  }, null, 8, ["modelValue"]),
                  _cache[38] || (_cache[38] = _createElementVNode("i", { class: "feature-ico i-nosmoke" }, null, -1)),
                  _cache[39] || (_cache[39] = _createElementVNode("span", null, "No Smoking", -1))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_switch, {
                    modelValue: form.value.gps,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.gps) = $event))
                  }, null, 8, ["modelValue"]),
                  _cache[40] || (_cache[40] = _createElementVNode("i", { class: "feature-ico i-gps" }, null, -1)),
                  _cache[41] || (_cache[41] = _createElementVNode("span", null, "GPS", -1))
                ])
              ])
            ]),
            _: 1,
            __: [42]
          }),
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "section-card"
          }, {
            default: _withCtx(() => [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "section-title" }, "PHOTO", -1)),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(displayPhotoLabels, (label, idx) => {
                  return _createElementVNode("div", {
                    key: idx,
                    class: "photo-slot"
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      (imageFields.value[idx]?.preview)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: imageFields.value[idx]!.preview,
                            class: "slot-img",
                            alt: "preview"
                          }, null, 8, _hoisted_22))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[43] || (_cache[43] = [
                            _createElementVNode("div", { class: "upload-arrow" }, "⬆︎", -1)
                          ]))),
                      _createElementVNode("input", {
                        class: "upload-input",
                        type: "file",
                        accept: "image/png,image/jpeg",
                        onChange: ($event: any) => (handleImageUpload($event, idx))
                      }, null, 40, _hoisted_24),
                      (imageFields.value[idx])
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "remove-button",
                            type: "button",
                            onClick: ($event: any) => (removeImage(idx)),
                            "aria-label": "Remove"
                          }, " ✕ ", 8, _hoisted_25))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(label), 1)
                  ])
                }), 64))
              ])
            ]),
            _: 1,
            __: [44]
          }),
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "section-card"
          }, {
            default: _withCtx(() => [
              _cache[48] || (_cache[48] = _createElementVNode("div", { class: "section-title" }, "GPS CONFIGURATION", -1)),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "info-label" }, "Latitude", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.location.lat,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.location.lat) = $event)),
                    modelModifiers: { number: true },
                    type: "number",
                    placeholder: "auto from Geotek",
                    class: "ghost-input",
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[46] || (_cache[46] = _createElementVNode("span", { class: "info-label" }, "Longitude", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.location.lng,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.location.lng) = $event)),
                    modelModifiers: { number: true },
                    type: "number",
                    placeholder: "auto from Geotek",
                    class: "ghost-input",
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[47] || (_cache[47] = _createElementVNode("span", { class: "info-label" }, "Current Location", -1)),
                  _createVNode(_component_el_input, {
                    modelValue: form.value.current_location,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.current_location) = $event)),
                    placeholder: "tap to enter",
                    class: "ghost-input",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1,
            __: [48]
          }),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "large",
              class: "save-btn",
              loading: isLoading.value,
              disabled: isLoading.value,
              onClick: submitForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isLoading.value ? 'SAVING...' : 'SAVE'), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})